module.exports = __webpack_public_path__ + "img/039-ironing.49cfecde.svg";